/**
 * PDP specific custom code
 */


// Photoswipe code pulled from theme.js because theme.min.js photoswipe won't run on config PDP
// slightly modified to work with data given
function createPhotoSwipeItemsFromImages(images) {
  const imgsArr = Array.from(images);
  const initialWidth = imgsArr[0].naturalWidth;
  return imgsArr.map(function (image) {
    var maxWidth = parseInt(initialWidth),
      maxHeight = parseInt(initialWidth),
      maxDimension = window.innerWidth < 768 ? 1200 : 1800,
      // 1200 is max size for mobile and 1800 for larger devices
      reduceFactor = 1.0;

    if (maxWidth >= maxHeight) {
      reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
    } else {
      reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
    }

    var requestedWidth = Math.floor(maxWidth / reduceFactor);
    var requestedHeight = Math.floor(maxHeight / reduceFactor);

    return {
      msrc: image.currentSrc || image.src, // For browser that supports srcset, currentSrc is the currently used image
      w: requestedWidth,
      h: requestedHeight,
      initialZoomLevel: 1.6,
      src: image.getAttribute('data-original-src')
    };
  });
}

function createPhotoSwipe(items, selectedImageIndex) {

  var photoswipeContainer = document.querySelector('.pswp');
  this.delegateRoot = new domDelegate.Delegate(document.body);

  var delegatedRoot = this.delegateRoot;
  this.photoSwipeInstance = new PhotoSwipe(photoswipeContainer, false, items, {
    index: selectedImageIndex,
    showHideOpacity: true,
    showAnimationDuration: 500,
    loop: false,
    history: false,
    closeOnVerticalDrag: false,
    allowPanToNext: false,
    pinchToClose: false,
    errorMsg: '<p class="pswp__error-msg">' + window.languages.productImageLoadingError + '</p>',
    scaleMode: 'zoom',
    getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
      if (isMouseClick) {
        return 1.6;
      } else {
        return item.initialZoomLevel < 0.7 ? 1 : 1.33;
      }
    }
  });

  function _onSlideChanged() {
    if (this.photoSwipeInstance.getCurrentIndex() === 0) {
      this.photoSwipeInstance.scrollWrap.querySelector('.pswp__button--prev').setAttribute('disabled', 'disabled');
    } else {
      this.photoSwipeInstance.scrollWrap.querySelector('.pswp__button--prev').removeAttribute('disabled');
    }

    if (this.photoSwipeInstance.getCurrentIndex() + 1 === this.photoSwipeInstance.options.getNumItemsFn()) {
      this.photoSwipeInstance.scrollWrap.querySelector('.pswp__button--next').setAttribute('disabled', 'disabled');
    } else {
      this.photoSwipeInstance.scrollWrap.querySelector('.pswp__button--next').removeAttribute('disabled');
    }
  }

  function _onSingleTap(event) {
    if (!event.detail || event.detail.pointerType === 'mouse') {
      if (event.target.classList.contains('pswp__img')) {
        this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
      }
    } else {
      if (event.target.classList.contains('pswp__button')) {
        return;
      }

      event.target.closest('.pswp').querySelector('.pswp__ui').classList.toggle('pswp__ui--hidden');
    }
  }

  function _onDoubleTap(point) {
    var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

    if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
      this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
    } else {
      this.photoSwipeInstance.zoomTo(initialZoomLevel < 0.7 ? 1 : 1.33, point, 333);
    }
  }

  function _onInitialZoomIn() {
    document.querySelector('.pswp__ui').classList.remove('pswp__ui--hidden');
  }

  function _onInitialZoomOut() {
    document.querySelector('.pswp__ui').classList.add('pswp__ui--hidden');
  }

  function _onProductVariantChanged() {
    this.photoSwipeInstance.goTo(0);
  }

  this.photoSwipeInstance.listen('beforeChange', _onSlideChanged.bind(this));
  this.photoSwipeInstance.listen('destroy', function () {
    delegatedRoot.off('pswpTap');
    this.photoSwipeInstance = null;
  });
  this.photoSwipeInstance.listen('doubleTap', _onDoubleTap.bind(this));
  this.photoSwipeInstance.listen('initialZoomIn', _onInitialZoomIn.bind(this));
  this.photoSwipeInstance.listen('initialZoomOut', _onInitialZoomOut.bind(this));

  this.delegateRoot.on('pswpTap', '.pswp__scroll-wrap', _onSingleTap.bind(this));
  this.delegateRoot.on('pswpTap', '.pswp__button--close', this.photoSwipeInstance.close);
  this.delegateRoot.on('pswpTap', '.pswp__button--prev', this.photoSwipeInstance.prev);
  this.delegateRoot.on('pswpTap', '.pswp__button--next', this.photoSwipeInstance.next);

  this.photoSwipeInstance.init();
}

/**
 * PDP specific custom code
 */

function createSliders(initialScrollPos) {
  if (typeof (document.querySelector('.Product__Gallery')) != 'undefined' && document.querySelector('.Product__Gallery') != null) {

    var mainSliderConfig = {};
    var thumbSliderConfig = {};

    // Config won't work with options in template, need them manually stated here 
    if (typeof (document.querySelector('.ProductConfigurator')) != 'undefined' && document.querySelector('.ProductConfigurator') != null) {
      mainSliderConfig = {
        "prevNextButtons": true,
        "pageDots": true,
        "asNavFor": ".Product__SlideshowNav--thumbnails",
        "wrapAround": true,
        "adaptiveHeight": false,
        "watchCSS": false,
        "imagesLoaded": true,
        "cellSelector": ".Carousel__Cell",
        "draggable": true,
        "initialIndex": 0
      };

      thumbSliderConfig = {
        "prevNextButtons": true,
        "draggable": false,
        "percentPosition": false,
        "contain": "1",
        "imagesLoaded": true,
        "pageDots": false,
        'cellAlign': 'left',
        "wrapAround": false,
        "cellSelector": ".Carousel__Cell"
      };
    }


    var mainProductSliderElement = document.querySelector('.Product__Slideshow'),
      thumbnailSliderElement = document.querySelector('.Product__SlideshowNav--thumbnails'),
      mainProductSlider = Flickity.data(mainProductSliderElement),
      thumbnailSlider = Flickity.data(thumbnailSliderElement);


    if (mainProductSliderElement.classList.contains('flickity-enabled')) {

      var parent = document.querySelector('.Product__Slideshow .flickity-slider');
      var thumbParent = document.querySelector('.Product__SlideshowNav--thumbnails .flickity-slider');

      while (parent.firstChild) {
        parent.removeChild(parent.firstChild);
        thumbParent.removeChild(thumbParent.firstChild);
      }

      mainProductSlider.destroy();
      thumbnailSlider.destroy();

    }
    // mainProductSlider = new Flickity('.Product__Slideshow', mainSliderConfig);
    // thumbnailSlider = new Flickity('.Product__SlideshowNav--thumbnails', thumbSliderConfig);    

    // on change isn't firing, only select. Might be an old version of flickity?
    var currentSliderIndex = mainProductSlider.selectedIndex;

    mainProductSlider.on('select', function () {
      // Keeps carousel from selecting back and forth, forever
      if (currentSliderIndex != this.selectedIndex) {
        currentSliderIndex = this.selectedIndex;
        thumbnailSlider.select(this.selectedIndex);
      } else {
        return;
      }
    });

    //need to manually add click to navigate thumb carousel on configurator, don't know why
    document.querySelectorAll('.Product__SlideshowNav--thumbnails img').forEach(function (thumbImg) {
      thumbImg.addEventListener('click', function (e) {
        if (currentSliderIndex != this.getAttribute('data-image-media-position')) {
          currentSliderIndex = this.getAttribute('data-image-media-position');
          thumbnailSlider.select(currentSliderIndex);
        }
      });
    });
  }

  if (initialScrollPos && window.pageYOffset > initialScrollPos) {
    window.scrollTo(0, initialScrollPos);
  }

  this.pdpGalleryThumbs = thumbnailSlider;
}


function createPhotoswipe() {
  document.querySelectorAll('.Product__Slideshow .Product__SlideItem--image img').forEach(function (productImg) {
    productImg.addEventListener('click', function (e) {
      var images = document.querySelectorAll('.Product__Slideshow .Product__SlideItem--image img')
      var imageLength = parseInt(images.length);
      var activeIndex = this.closest('.swiper').swiper.activeIndex;
      var slides = parseInt(this.closest('.swiper').swiper.slides.length);
      var subtractBy = slides - imageLength;
      createPhotoSwipe(createPhotoSwipeItemsFromImages(images), parseInt(activeIndex) - subtractBy);
    });
  });
}


window.addEventListener("load", function (event) {
  if (typeof (document.querySelector('.ProductConfigurator')) != 'undefined' && document.querySelector('.ProductConfigurator') != null) {
    // createSliders();
    createPhotoswipe();
  }

  // Handles PDP Reviews
  const reviewPreviewContainer = document.querySelector('.ProductMeta__ReviewPreview');
  const reviewSectionContainer = document.querySelector('#reviews');
  const writeReviewPreviewButton = document.querySelectorAll('.ReviewPreview__WriteReview');
  const writeReviewButton = document.querySelector('.jdgm-write-rev-link');
  const reviewPreview = document.querySelectorAll('.ProductMeta .jdgm-prev-badge, .ProductMetaMobile .jdgm-prev-badge');
  if (reviewPreviewContainer && reviewSectionContainer && writeReviewPreviewButton && writeReviewButton) {
    for (let i = 0; i < writeReviewPreviewButton.length; i++) {
      writeReviewPreviewButton[i].addEventListener('click', (event) => {
        window.scrollTo({ top: reviewSectionContainer.offsetTop - 60, behavior: 'smooth' });
        if (!writeReviewButton.classList.contains('close-form-btn')) {
          writeReviewButton.click();
        }
      });
    }

    if (reviewPreview) {
      for (let i = 0; i < reviewPreview.length; i++) {
        reviewPreview[i].addEventListener('click', (event) => {
          window.scrollTo({ top: reviewSectionContainer.offsetTop - 60, behavior: 'smooth' });
        });
      }
    }

    const badgeTextElement = document.querySelector('.ProductDetails .jdgm-prev-badge__text');
    const badgeTextElementMobile = document.querySelector('.ProductMetaMobile .jdgm-prev-badge__text');
    const reviewsPreviewElement = document.querySelector('.ProductDetails .jdgm-prev-badge');
    const numberOfReviews = reviewsPreviewElement ? reviewsPreviewElement.dataset.numberOfReviews : '0';

    if (numberOfReviews && numberOfReviews !== '0') {
      if (badgeTextElement && badgeTextElement.textContent.match(/\([0-9]+\)/) === null) {
        badgeTextElement.innerHTML = `(${numberOfReviews})`;
      }
      if (badgeTextElementMobile && badgeTextElementMobile.textContent.match(/\([0-9]+\)/) === null) {
        badgeTextElementMobile.innerHTML = `(${numberOfReviews})`;
      }
    }

    if (badgeTextElement) {
      badgeTextElement.style.display = 'initial';
    }

    if (badgeTextElementMobile) {
      badgeTextElementMobile.style.display = 'initial';
    }
  }
}, false);

/* from main-product-standard inline js */
function colorSelectionChanged(el) {
  var parentContainer = el.closest('.product-color-info-container');
  var wholeContainer = el.closest('.product-variants');
  var prevSelection = wholeContainer.querySelector('.ColorSwatchList .HorizontalList__Item.Selected');
  if (prevSelection) {
    prevSelection.classList.remove('Selected');
    Array.from(wholeContainer.querySelectorAll('.SelectedColor')).forEach((color) => { color.innerText="";});
    if(wholeContainer.querySelector('.EstimatedShipDateCustom')){
      wholeContainer.querySelector('.EstimatedShipDateCustom').innerText = '';
    }
    if(wholeContainer.querySelector('.EstimatedShipDateQuick')){
      wholeContainer.querySelector('.EstimatedShipDateQuick').innerText = '';
    }
  }
  el.parentElement.parentElement.classList.add('Selected');
  updateSelectedVariant(wholeContainer, parentContainer);
}

let pdpPreloadedVarImages = false;
function updateSelectedVariant(wholeContainer, parentContainer) {
  var swipermain = document.querySelector('.main-swiper').swiper;
  swipermain.slideTo(0);
  if (product.variants.length == 1) {
    selectedVariant = product.variants[0];
    var el = document.getElementById('SelectedVariantId');
    el.value = selectedVariant.id;
  } else {
    var optionCount = product.options.length;
    var selectedOptions = [];
    var inputs = document.getElementsByClassName('variant-option');
    Array.from(inputs).forEach((input) => {
      if (input.checked) {
        selectedOptions[input.dataset.optionposition] = input.dataset.optionvalue;
      }
    });
    if(document.querySelectorAll('.ColorSwatchList .HorizontalList__Item.Selected')){
      selectedColors = document.querySelectorAll('.ColorSwatchList .HorizontalList__Item.Selected');
      Array.from(selectedColors).forEach((selectedColor) => {
        var newparentContainer = selectedColor.parentElement.parentElement.parentElement.parentElement;
        newparentContainer.querySelector('.SelectedColor').innerText = selectedColor.dataset.colorTitle;
        selectedOptions[selectedColor.dataset.optionposition] = selectedColor.dataset.optionvalue;
        if(newparentContainer.querySelector('.EstimatedShipDateCustom')){
          newparentContainer.querySelector('.EstimatedShipDateCustom').style.display = "inline";
        }
      });
    }

    var variantSet = product.variants;
    for (let x = 0; x < optionCount; x++) {
      variantSet = variantSet.filter(v => v.options[x] == selectedOptions[x + 1]);
    }
    if (variantSet.length == 1) {
      let exactMatchImageNodes = document.querySelectorAll(".Product__Gallery img[srcset*='/VARIANT-']");
      selectedVariant = variantSet[0];
      selectedVariant.product_id = product.id;
      var el = document.getElementById('SelectedVariantId');
      el.value = selectedVariant.id;
      var newSrc = selectedVariant.featured_image.src + '&width=1000';
      exactMatchImageNodes.forEach(el => {
        el.srcset = newSrc;
        el.setAttribute('data-original-src', newSrc);
      });
    }
  }

  var upperPriceBlock = document.querySelector(".upper-price-block");
  var upbInnerHtml = "";
  if (selectedVariant.compare_at_price != null) {
    upbInnerHtml += "<span class='text-bold strikethrough compare-at-price ' style='margin-right: 10px;'>";
    upbInnerHtml += formatter.format(selectedVariant.compare_at_price / 100);
    upbInnerHtml += "</span>";
    upbInnerHtml += "<span class='color-red'>";
    upbInnerHtml += "Limited Time <span class='calculated-price'>" + formatter.format(selectedVariant.price / 100);
    upbInnerHtml += "</span>";
  } else {
    upbInnerHtml += "<span>";
    upbInnerHtml += formatter.format(selectedVariant.price / 100);
    upbInnerHtml += "</span>";
  }
  upperPriceBlock.innerHTML = upbInnerHtml;

  var lowerPriceBlock = document.querySelector(".lower-price-block");
  var lpbInnerHtml = "";
  if (selectedVariant.compare_at_price != null ) {
    lpbInnerHtml += "<div class='text-bold strikethrough' style='font-size: 22px;'>";
    lpbInnerHtml += formatter.format(selectedVariant.compare_at_price / 100);
    lpbInnerHtml += "</div>";
    lpbInnerHtml += "<div class='ProductForm__PricePreview__PriceDisplay DynamicVariantPriceDisplay color-red text-large calculated-price' style='margin: 10px 0 10px 0;'>";
    lpbInnerHtml += formatter.format(selectedVariant.price / 100);
    lpbInnerHtml += "</div>";
  } else {
    lpbInnerHtml += "<div class='ProductForm__PricePreview__PriceDisplay DynamicVariantPriceDisplay text-large calculated-price' style='margin: 10px 0 10px 0;'>";
    lpbInnerHtml += formatter.format(selectedVariant.price / 100);
    lpbInnerHtml += "</div>";
  }
  lowerPriceBlock.innerHTML = lpbInnerHtml;

  var stickyHeaderPrice = document.querySelector(".StickyCustomizeHeader>div>.calculated-price");
  stickyHeaderPrice.innerText = formatter.format(selectedVariant.price / 100);

  //update lead time
  var leadTimeMsg = "";
  var  orderleadTimeMsg = "";
  var outofstock = false;
  if (inStockFlags[selectedVariant.id] == "true"){
    if (restockDates[selectedVariant.id]) {
      var restockDate = new Date(restockDates[selectedVariant.id]);
      day = restockDate.getDate();
      month = months[restockDate.getMonth()];
      if (day <= "10") {
        leadTimeMsg = "Order now, and we'll ship when it's available. Estimated early " + month + ".";
        orderleadTimeMsg="Back in stock early  "+ month + ".";
        outofstock=true;
      } else if (day <= "20") {
        leadTimeMsg = "Order now, and we'll ship when it's available. Estimated mid " + month + ".";
        orderleadTimeMsg="Back in stock  mid "+ month + ".";
        outofstock=true;
      } else {
        leadTimeMsg = "Order now, and we'll ship when it's available. Estimated late " + month + ".";
        orderleadTimeMsg="Back in stock late "+ month + ".";
        outofstock=true;
      }
    } else {
      leadTimeMsg = "Usually ships in " + stockLeadTimes[selectedVariant.id] + " business days.";
      orderleadTimeMsg="In stock & ready to ship.";
    }
  } else {
    var leadTimeWeeks = Math.ceil(mtoLeadTimes[selectedVariant.id] / 5);
    if (leadTimeWeeks == 0){
      CustomleadTimeMsg = "";
      CustomorderleadTimeMsg = "";
      leadTimeMsg = "";
    } else if (leadTimeWeeks > 0) {
      CustomleadTimeMsg = "Usually ships in approximately " + leadTimeWeeks + " weeks.";
      CustomorderleadTimeMsg = "Usually ships in approximately " + leadTimeWeeks + " weeks.";
      leadTimeMsg = "Custom order ships in approximately " + leadTimeWeeks + " weeks.";
    }
  }
  if (inStockFlags[selectedVariant.id] == "true"){
    if(wholeContainer.querySelector('.OrderShipDateMsgQuick')){
      var orderLeadTime = wholeContainer.querySelector('.OrderShipDateMsgQuick');
      orderLeadTime.value="Quick ship: " + orderleadTimeMsg;
    }
    if(wholeContainer.querySelector('.RestockDateQuick')){
      var orderRestockDate = wholeContainer.querySelector('.RestockDateQuick');
      orderRestockDate.value=restockDates[selectedVariant.id];
    }
    if(wholeContainer.querySelector('.StockedSkuQuick')){
      var orderStockedSku = wholeContainer.querySelector('.StockedSkuQuick');
      orderStockedSku.value=inStockFlags[selectedVariant.id];
    }
    if(document.getElementById('EstimatedShipDateQuick')){
      document.getElementById('EstimatedShipDateQuick').innerText = leadTimeMsg;
    }
  } else {
    if(document.getElementById('EstimatedShipDateQuick')){
      document.getElementById('EstimatedShipDateQuick').innerText = '';
    }
    if(wholeContainer.querySelector('.EstimatedShipDateCustom')){
      var leadTimeCustom = wholeContainer.querySelector('.EstimatedShipDateCustom');
      leadTimeCustom.innerText = CustomleadTimeMsg;
    }
    if(wholeContainer.querySelector('.OrderShipDateMsgCustom')){
      var orderLeadTime = wholeContainer.querySelector('.OrderShipDateMsgCustom');
      orderLeadTime.value= "Custom order: " + CustomorderleadTimeMsg;
    }
    if(document.getElementById('OrderShipDateMsgCustom')){
      document.getElementById('OrderShipDateMsgCustom').value ="Custom order: " + CustomorderleadTimeMsg;
    }
    if(wholeContainer.querySelector('.RestockDateCustom')){
      var orderRestockDate = wholeContainer.querySelector('.RestockDateCustom');
      orderRestockDate.value=restockDates[selectedVariant.id];
    }
    if(wholeContainer.querySelector('.StockedSkuCustom')){
      var orderStockedSku = wholeContainer.querySelector('.StockedSkuCustom');
      orderStockedSku.value="inStockFlags[selectedVariant.id]";
    }
  }
  var leadTimeEl = document.getElementById('EstimatedShipDate');
  leadTimeEl.innerText = leadTimeMsg;
  var leadTimestock = document.getElementById('EstimatedShipDateOutofstock');
  leadTimestock.value = orderleadTimeMsg;
  if(outofstock != false) {
    leadTimeEl.style.color = "#a12a3f";
  } else{
    leadTimeEl.style.color="#001D34";
  }
  updateAffirm();
  if(!pdpPreloadedVarImages && pdpVariantImages){
    for(var i = 0; i < pdpVariantImages.length; i++){
      let imgTag = new Image;
      imgTag.src = pdpVariantImages[i];
    }
  }
}

function updateAffirm() {
  var qty = document.getElementsByName('quantity')[0].value;
  var affirmElement = document.querySelector(".affirm-as-low-as");
  affirmElement.setAttribute('data-amount', selectedVariant.price * qty);
  affirm.ui.refresh();
}

function decreaseQuantity() {
  const el = document.getElementById('main-product-quantity');
  if (el.value > 1) {
      el.value--;
      updateAffirm();
  }
}

function increaseQuantity() {
  const el = document.getElementById('main-product-quantity');
  if (el.value < 100) {
      el.value++;
      updateAffirm();
  }
}

function hideColorPopover(target) {
  let popoverEl = document.getElementById('ColorSwatchPopover');
  popoverEl.classList.add('hide');
  popoverEl.innerHTML = "";
}

function addToCart(event) {
  var _this7 = document.querySelector('.productStandardComponent');
  event.preventDefault();
  var addToCartButton = document.querySelector('.ProductForm__AddToCart');
  addToCartButton.setAttribute('disabled', 'disabled');
  _this7.dispatchEvent(new CustomEvent('theme:loading:start'));
  var formElement = document.querySelector('form[action*="/cart/add"]');
  var leadTimeEl = document.getElementById('EstimatedShipDate');

  if (inStockFlags[selectedVariant.id] == "true"){
    if (restockDates[selectedVariant.id]) {
      var orderLeadTime = document.getElementById('EstimatedShipDateOutofstock');
    } else {
      var orderLeadTime = document.getElementById('OrderShipDateMsgQuick');
    }
    var orderRestockDate = document.getElementById('RestockDateQuick');
    var orderStockedSku = document.getElementById('StockedSkuQuick');
  } else {
    var orderLeadTime = document.getElementById('OrderShipDateMsgCustom');
    var orderRestockDate = document.getElementById('RestockDateCustom');
    var orderStockedSku = document.getElementById('StockedSkuCustom');
  }
  const stockSkuType=orderStockedSku.value=='true'?true:false;
  const mtoSkuType=orderStockedSku.value!='true'?true:false;
  const orderRestockDateType=orderRestockDate.value!=''?true:false;

  var cartReq = {
    items: [{
      quantity: document.getElementsByName('quantity')[0].value,
      properties: {
      ...(stockSkuType && {"Stocked Lead Time":orderLeadTime.value}),
      ...(mtoSkuType && {"MTO Lead Time":orderLeadTime.value}),
      ...(orderRestockDateType && {"Restock Date":orderRestockDate.value}),
      ...(pdpIsOutlet && {"Outlet":pdpOutletMsg})            },
      id: selectedVariant.id
    }]
  };

  fetch(window.routes.cartAddUrl + '.js', {
    body: JSON.stringify(cartReq),
    credentials: 'same-origin',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
    }
  }).then(function(response) {
      _this7.dispatchEvent(new CustomEvent('theme:loading:end'));
      if (response.ok) {
        addToCartButton.removeAttribute('disabled');
        response.json().then(function(content) {
          var qty = parseInt(formElement.querySelector('[name="quantity"]').value);
          if(window.theme.addSuccessPopup){
            hwGetATCSuccess(content.items[0].key,selectedVariant,qty,_this7);
          } else {
            _this7.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                variant: _this7.currentVariant,
                quantity: qty
              }
            }));
          }
        });
      } else {
        response.json().then(function(content) {
          var errorMessageElement = document.createElement('span');
          errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
          errorMessageElement.innerHTML = content['description'];
          addToCartButton.removeAttribute('disabled');
          addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
          setTimeout(function() {
            errorMessageElement.remove();
          }, 2500);
        });
      }
  });
  event.preventDefault();
}

document.body.addEventListener('change', function(e) {
  var wholeContainer = e.srcElement.closest('.product-variants');
  updateSelectedVariant(wholeContainer);
});

var addToCartBtn = document.getElementById('AddToCartBtn');
document.addEventListener('scroll', function(e) {
  var buttonPos = addToCartBtn.getBoundingClientRect();
  if (buttonPos.bottom < 62 && window.innerWidth < 749) {
    showStickyHeader();
  } else {
    hideStickyHeader();
  }
});
if(document.querySelectorAll('.ColorSwatchList .HorizontalList__Item.Selected')){
  selectedColorEls = document.querySelectorAll('.ColorSwatchList .HorizontalList__Item.Selected');
  Array.from(selectedColorEls).forEach((selectedColorEl) => {
    var parentContainer = selectedColorEl.parentElement.parentElement.parentElement.parentElement;
    parentContainer.querySelector('.SelectedColor').innerText = selectedColorEl.dataset.colorTitle
  });
}

function showColorPopover(target) {
  var optionName = target.dataset.optionname;
  if(pdpDisabledSwatches != null){
    if(pdpDisabledSwatches.indexOf(optionName) != -1){
      return;
    }
  }
  let swatchUrl = "https://ecommerceazurefunctions.blob.core.windows.net/surfaces/" + target.dataset.colorCode.toUpperCase() + ".jpg";
  let popover = "";

  var arrowLeft = target.offsetLeft + (target.offsetWidth / 2) - 3;
  popover += "<style>#ColorSwatchPopover:before{left:" + arrowLeft + "px;}#ColorSwatchPopover:after{left:" + arrowLeft + "px;}.ColorSwatch__Popover .ColorSwatch__Popover__Color{height: 125px;}</style>";

  popover += "<div class='ColorSwatch__Popover__Color'>";
  popover += "<div class='ColorSwatch_ImageWrapper'>";
  popover += "<img  class='full-width Image--lazyLoad' loading='lazy' src='" + swatchUrl + "' alt='" + target.dataset.colorTitle + "'>";
  popover += "</div>";
  popover += "</div>";
  popover += "<div style='font-size: 18px; padding: 10px; line-height: 1.2;'>";
  popover += "<p class='ColorSwatch__Popover__Title'>" + target.dataset.colorTitle + "</p>";
  popover += "<p style='text-align: left;'>" + target.dataset.colorDescription + "</p>";

  popover += "<div class='ColorSwatch__Popover__Characteristics'>";
  target.dataset.colorCharacteristics.split('|').forEach(function(characteristic) {
    switch (characteristic) {
      case "Durable":
        popover += "<div class='ColorSWatch__Popover__Characteristic'>";
        popover += "<svg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 160 160'><defs><style>.cls-1{fill:none;stroke:#001d34;stroke-miterlimit:10;stroke-width:2.5px;}</style></defs><path class='cls-1' d='M155.05,80A75.05,75.05,0,1,1,80.16,5,75,75,0,0,1,155.05,80Z'/><path class='cls-1' d='M85.5,67a21.26,21.26,0,0,1,2.75,2.32h0a20.48,20.48,0,0,1,0,29L70.39,116.16a20.46,20.46,0,0,1-28.95,0h0a20.48,20.48,0,0,1,0-28.95L58.5,70.15'/><path class='cls-1' d='M60.22,81.14,48.65,92.71a11.47,11.47,0,0,0,0,16.24h0a11.49,11.49,0,0,0,16.25,0l2.54-2.54,4-4L81,92.81a11.49,11.49,0,0,0,0-16.25h0a11.56,11.56,0,0,0-1.87-1.51'/><path class='cls-1' d='M86.47,42.18l.62-.62a20.46,20.46,0,0,1,29,0h0a20.46,20.46,0,0,1,0,29L99,87.57'/><path class='cls-1' d='M72,90.68a20.65,20.65,0,0,1-2.75-2.31h0a20.47,20.47,0,0,1,0-29L82.49,46.16'/><path class='cls-1' d='M78.32,82.68a11.63,11.63,0,0,1-1.87-1.52h0a11.49,11.49,0,0,1,0-16.25L92.59,48.77a11.49,11.49,0,0,1,16.25,0h0a11.5,11.5,0,0,1,0,16.25L97.27,76.58'/></svg>";
        popover += "<div>" + characteristic + "</div>";
        popover += "</div>";
        break;
      case "Stain Resistant":
        popover += "<div class='ColorSWatch__Popover__Characteristic'>";
        popover += "<svg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 160 160'><defs><style>.cls-1{fill:none;stroke:#001d34;stroke-miterlimit:10;stroke-width:2.5px;}</style></defs><path class='cls-1' d='M155.05,80A75.05,75.05,0,1,1,80.16,5,75,75,0,0,1,155.05,80Z'/><path class='cls-1' d='M63,55V46.4a6.32,6.32,0,0,1,7.39-6.65,6.47,6.47,0,0,1,5.31,7.43l-2,9.23-.62,2.87'/><path class='cls-1' d='M64.1,112.1A9,9,0,1,0,81.81,115l2-9.45a5.19,5.19,0,0,1,6.58-3.89c2.14.64,4.67,1.39,7.09,2.07'/><path class='cls-1' d='M105.3,105.68a7.23,7.23,0,0,0,8.32-6c.59-3.54-1.39-7.31-4.82-8l-5.7-1.38-1.69-.43'/><path class='cls-1' d='M115.62,64.19a6.88,6.88,0,1,1-2.25,13.57l-9.54-1'/><path class='cls-1' d='M98,55.16a6.81,6.81,0,1,0-13.44-2.23l-.22,1-.27,1.42'/><path class='cls-1' d='M55.62,63.18l-4-.66A13.8,13.8,0,0,0,35.79,73a13.52,13.52,0,0,0,11,16.16l.36.07'/><path class='cls-1' d='M82.48,61.22c-.87,2.32-3.12,4.22-5.71,3.66a4.8,4.8,0,0,1-3.66-5.72'/><path class='cls-1' d='M98,54.89c-.12.91-.46,2.6-.87,4.48a6.29,6.29,0,0,0,8.24,7.32l.1,0,5.43-2.09a7.22,7.22,0,0,1,4.91-.33'/><path class='cls-1' d='M104.29,76.81A6.71,6.71,0,0,0,101.72,90'/><circle class='cls-1' cx='103.46' cy='38.4' r='3.71'/><circle class='cls-1' cx='42.49' cy='105.03' r='7.58'/><circle class='cls-1' cx='129.17' cy='77.95' r='3.71'/><line class='cls-1' x1='27.49' y1='26.57' x2='132.55' y2='133.49'/><path class='cls-1' d='M61.73,60.23a5.74,5.74,0,0,1-6,3l-.14,0'/><path class='cls-1' d='M65.62,105.18l.16-.89.69-4.28a7.69,7.69,0,0,0-6.37-8.82l-1.89-.27'/><line class='cls-1' x1='58.3' y1='90.94' x2='46.96' y2='89.17'/></svg>";
        popover += "<div>" + characteristic + "</div>";
        popover += "</div>";
        break;
      case "Textured":
        popover += "<div class='ColorSWatch__Popover__Characteristic'>";
        popover += "<svg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 160 160'><defs><style>.cls-1{fill:none;stroke:#002a3a;stroke-miterlimit:10;stroke-width:2.5px;}.cls-2{fill:#fff;}</style></defs><polyline class='cls-1' points='112.3 93.86 116.87 89.3 108.95 81.38'/><line class='cls-1' x1='107.74' y1='98.43' x2='112.3' y2='93.86'/><polyline class='cls-1' points='81.55 108.78 89.47 116.7 98.6 107.57 107.74 116.7 116.87 107.57 107.74 98.43'/><polyline class='cls-1' points='63.31 108.78 71.22 116.7 80.36 107.57 89.49 116.7'/><polyline class='cls-1' points='116.87 71.03 107.74 61.89 116.87 52.76 107.74 43.62 98.6 52.76 89.47 43.62 80.33 52.76 71.2 43.62 62.06 52.76 52.93 43.62 43.79 52.76 52.93 61.89 43.79 71.03 52.93 80.16 43.79 89.3 52.93 98.43 43.79 107.57 52.93 116.7 62.06 107.57 71.2 116.7'/><polyline class='cls-1' points='107.74 61.89 116.87 71.03 107.74 80.16 116.87 89.3 116.55 89.62'/><line class='cls-1' x1='80.33' y1='52.76' x2='80.33' y2='107.57'/><line class='cls-1' x1='98.6' y1='52.76' x2='98.6' y2='107.57'/><line class='cls-1' x1='62.06' y1='52.76' x2='62.06' y2='107.57'/><line class='cls-1' x1='51.08' y1='80.16' x2='108.13' y2='80.16'/><line class='cls-1' x1='52.93' y1='61.89' x2='107.74' y2='61.89'/><line class='cls-1' x1='52.93' y1='98.43' x2='107.74' y2='98.43'/><path class='cls-1' d='M155.05,80A75.05,75.05,0,1,1,80.16,5,75,75,0,0,1,155.05,80Z'/><rect class='cls-2' x='110.32' y='101.15' width='4.55' height='4.55' transform='translate(106.11 -49.32) rotate(45)'/></svg>";
        popover += "<div>" + characteristic + "</div>";
        popover += "</div>";
        break;
      case "Greenguard Certified":
        popover += "<div class='ColorSWatch__Popover__Characteristic'>";
        popover += "<svg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 160 160'><defs><style>.cls-1{fill:none;stroke:#002a3a;stroke-miterlimit:10;stroke-width:2.5px;}</style></defs><polyline class='cls-1' points='80 53.83 116.27 53.83 116.27 73.61 80 53.96 43.73 73.61 43.73 53.83 53.87 53.83 53.87 43.74 63.96 43.74 63.96 55.03'/><line class='cls-1' x1='43.73' y1='115.03' x2='43.73' y2='82.53'/><line class='cls-1' x1='116.27' y1='82.53' x2='116.27' y2='115.03'/><polyline class='cls-1' points='87.35 114.86 87.35 83.92 98.27 83.92 98.27 114.86'/><rect class='cls-1' x='60.73' y='83.92' width='10.92' height='10.77'/><path class='cls-1' d='M155,80A75,75,0,1,1,80.16,5,75,75,0,0,1,155,80Z'/></svg>";
        popover += "<div>" + characteristic + "</div>";
        popover += "</div>";
        break;
    }
  });

  popover += "</div>";
  popover += "<p style='text-align: left; margin-bottom: 10px;'>Contents:&nbsp;&nbsp;" + target.dataset.colorContents + "</p>";
  popover += "</div>";

  let popoverEl = document.getElementById('ColorSwatchPopover');
  let bcrFirst = popoverEl.parentElement.getBoundingClientRect();
  let bcrCurrent = target.getBoundingClientRect();

  popoverEl.innerHTML = popover;
  if(optionName == 'Top Color'){
    popoverEl.style.top = (target.offsetTop + 213) + "px";
  } else if(optionName == 'Base Color'){
    popoverEl.style.top = (target.offsetTop + 393) + "px";
  } else {
    popoverEl.style.top = (target.offsetTop - 13) + "px";
  }
  popoverEl.classList.remove('hide');
}

let is3DModelLibsLoaded = false;
function show3DModel(event, ) {
  if (!is3DModelLibsLoaded) {
    // Array of BabylonJS libraries
    const babylonSourceLibs = [
        'https://cdn.haworth.com/haworth-configurator/0.0.33/assets/w-cf/libs/babylonjs/babylon.js',
        'https://cdn.haworth.com/haworth-configurator/0.0.33/assets/w-cf/libs/jszip/jszip.min.js',
        'https://cdn.haworth.com/haworth-configurator/0.0.33/assets/w-cf/scripts/utils.min.js',
        'https://cdn.haworth.com/haworth-configurator/0.0.33/assets/w-cf/scripts/core.min.js',
        'https://cdn.haworth.com/haworth-configurator/0.0.33/assets/w-cf/scripts/eaiws.min.js',
        'https://cdn.haworth.com/haworth-configurator/0.0.33/assets/w-cf/scripts/bsk.min.js',
        'https://cdn.haworth.com/haworth-configurator/0.0.33/assets/w-cf/scripts/cf.min.js',
        'https://cdn.haworth.com/haworth-configurator/0.0.33/assets/w-cf/scripts/pl.min.js',
        'https://cdn.haworth.com/haworth-configurator/0.0.33/assets/w-cf/libs/core-js/minified.js',
        'https://cdn.haworth.com/haworth-configurator/0.0.33/assets/w-cf/libs/pep/pep.min.js',
        'http://cdn.jsdelivr.net/g/filesaver.js'
    ];
    // Create script tags
    babylonSourceLibs.forEach(element => {
      let script = document.createElement('script');
      script.async = false;
      script.src = element;
      document.documentElement.firstChild.appendChild(script);
    });
  }

  document.getElementById('viewport-overlay').style.display = "flex";
  document.getElementById('viewport').innerHTML = "<div class='lds-facebook'><div></div><div></div><div></div></div>";

  let intervalID = setInterval(() => {
    if (typeof productConfigurator() !== 'undefined' && typeof egr != 'undefined') {
      clearInterval(intervalID);
      pcon = new pConService(
        'https://ocf2.haworth.com',
        'manual',
        pdpPconConfig.catalog,
        pdpPconConfig.catalog_id,
        pdpPconConfig.article_id,
        pdpPconConfig.article_number,
        pdpPconConfig.product_size,
        variantCodes[selectedVariant.id]
      );
      pcon.initialize();
      const initConfigurator = async() => {
        await pcon.initViewer(document.getElementById('viewport'));
        await pcon.updateProductPreview(
          pdpPconConfig.catalog,
          pdpPconConfig.catalog_id,
          pdpPconConfig.article_id,
          pdpPconConfig.article_number,
          variantCodes[selectedVariant.id]
        );
      };
      initConfigurator();
    }
  }, 1000);
  is3DModelLibsLoaded = true;
}

function hide3DModel() {
  document.getElementById('viewport-overlay').style.display = "none";
  document.getElementById('viewport').innerHTML = "";
}

function saveScreenshot() {
  pcon.saveScreenshot();
}

function showStickyHeader() {
  document.querySelector('.StickyCustomizeHeader').classList.remove('hide');
}

function hideStickyHeader() {
  document.querySelector('.StickyCustomizeHeader').classList.add('hide');
}

function formatPrice(price){
  price = formatter.format(price / 100);
  return price;
}